import { useDealContext } from "src/dm/components/DealLayout/DealLayout";
import DealAttachments from "src/dm/components/DealAttachments/DealAttachments";

// Page wrapper is intentionally thin — DealAttachments owns its own
// header ("Attachments (N)" + Upload button), so no duplicate <h2> here.
const DealAttachmentsPage = () => {
  const deal = useDealContext();
  return <DealAttachments dealId={deal.dealId} />;
};

export default DealAttachmentsPage;
